export default __webpack_public_path__ + "8077bd6e31e279e04a38e631b2d61a1e.png";